// extracted by mini-css-extract-plugin
module.exports = {"link":"_2eb2bfc"};